import { StyleSheet, Platform, StatusBar } from 'react-native';

import labelStyles from '@vfgroup-oneplatform/foundation/Components/Label/Label.Styles';
import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  btnBack: {
    left: 30,
    position: 'absolute',
    top: 30,
  },
  closeButton: {
    alignSelf: 'flex-end',
    marginRight: 20,
    marginTop: StatusBar.currentHeight,
  },
  insideBackBtnContainer: {
    marginBottom: 18,
  },
  insideBackBtn: {
    left: 18,
    position: 'absolute',
    top: 18,
  },
  firstLabel: {
    alignSelf: 'center',
    marginTop: 33.3,
  },
  firstLabelTextStyle: {
    color: Colors.white,
  },
  labelStyle: {
    flexDirection: 'row',
  },
  labelTextStyle: {
    color: Colors.white,
    textDecorationLine: 'underline',
  },
  thirdLabelTextStyle: {
    ...labelStyles.textStyle,
    color: Colors.white,
  },
  safeView: {
    flex: 1,
    flexDirection: 'column',
    zIndex: 1,
    justifyContent: 'center',
    position: 'relative'
  },
  scrollViewStyle: {
    flexGrow: 1,
    justifyContent: 'center',
  },
  secondLabel: {
    alignSelf: 'center',
    marginTop: 4,
  },
  thirdLabelContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
  },
  thirdLabel: {
    alignSelf: 'center',
    marginTop: 16.2,
    lineHeight: 22.9,
  },
  tobi: {
    alignSelf: 'center',
  },
  whiteBox: loginColors => ({
    backgroundColor: loginColors.loginBox,
    borderColor: Colors.transparent,
    borderRadius: 6,
    borderWidth: 1,
    flexDirection: 'column',
    marginHorizontal: 16,
    elevation: 5,
    shadowColor: Colors.shadow,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowRadius: 2,
    shadowOpacity: 1,
    ...Platform.select({
      web: {
        maxWidth: 850,
        width: '100%',
      },
      default: {
      }
    }),
  }),
  bubbleView: loginColors => ({
    backgroundColor: loginColors.bubbleView,
    borderColor: Colors.transparent,
    borderBottomLeftRadius: 16,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    borderWidth: 1,
    padding: 12,
    position: 'absolute',
    flexDirection: 'row',
    left: 16,
    marginTop: 22,
  }),
  bubbleText: loginColors => ({
    width: 215.3,
    fontSize: 16.6,
    lineHeight: 22.9,
    letterSpacing: 0,
    color: loginColors.bubbleViewText,
    flex: 1,
  }),
  textLabel: (colors, disabled) => ({
    color: disabled ? colors.biometricTextDisabled : colors.biometricText,
    fontFamily: Fonts.type.VFFont,
    fontSize: 16.6,
    lineHeight: 22.9,
    marginHorizontal: 4,
    alignSelf: 'center',
    paddingTop: 3,
  }),
  biometricTextView: {
    flexDirection: 'row',
    justifyContent: 'center',
    flex: 1,
    marginBottom: 15,
  },
  biometricIcon: (colors, disabled) => ({
    alignSelf: 'center',
    tintColor: disabled ? colors.biometricIconDisabled : colors.biometricIcon,
  }),
  subTitle: theme => ({
    color: theme.colors.sectionHeaderTextColor,
    fontSize: 17,
    marginHorizontal: 20,
    marginTop: 10,
    lineHeight: 25,
  }),
  titleStyle: theme => ({
    ...Fonts.type.bold,
    color: theme.colors.rememberMeText,
    fontSize: Platform.OS === 'ios' ? 16.6 : 16,
    marginHorizontal: 20,
    marginBottom: 7,
  }),
  divider: theme => ({
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.divider,
    marginHorizontal: 20,
    marginTop: 16,
  }),
  langContainer: {
    marginTop: 'auto',
  },
  langDivider: {
    borderBottomWidth: 1,
    marginHorizontal: 20,
    marginTop: 16,
    borderBottomColor: Colors.whiteRGBA(0.32),
  },

  langIcon: {
    marginHorizontal: 4,
  },
  changeLangContainer: {
    paddingVertical: 17.7,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },

  changeLangTextStyle: {
    paddingTop: 4,
    marginHorizontal: 4,
    color: Colors.white,
  },
});
